// redux_data/slices/gl_journal.js
import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';

const slice = createSlice({
  name: 'gl_journal',
  initialState: {
    isLoading:  false,
    hasError:   null,
    datas:      [],
    formValue:  {},
    start_date: new Date().toISOString().slice(0, 7) + '-01',  // first of current month
    end_date:   new Date().toISOString().slice(0, 10),
  },
  reducers: {
    startLoading: (state)          => { state.isLoading = true; },
    stopLoading:  (state)          => { state.isLoading = false; },
    setDatas:     (state, action)  => { state.datas     = action.payload; state.isLoading = false; },
    setFormValue: (state, action)  => { state.formValue = action.payload; },
    setStartDate: (state, action)  => { state.start_date = action.payload; },
    setEndDate:   (state, action)  => { state.end_date   = action.payload; },
    setHasError:  (state, action)  => { state.hasError   = action.payload; state.isLoading = false; },
    unsetError:   (state)          => { state.hasError   = null; },
  },
});

export const {
  setDatas, setFormValue, setStartDate,
  setEndDate, setHasError, unsetError,
} = slice.actions;

export function searchData({ data = {} } = {}) {
  return async (dispatch, getState) => {
    try {
      dispatch(slice.actions.startLoading());
      const state = getState().gl_journal;
      const payload = {
        start_date:  data.start_date  ?? state.start_date,
        end_date:    data.end_date    ?? state.end_date,
        status:      data.status      ?? undefined,
        source:      data.source      ?? undefined,
        with_lines:  data.with_lines  ?? "false",
        dc:          data.dc          ?? undefined,
        coa_code:    data.coa_code    ?? undefined,
      };
      const resp = await axios.post('/gl_journal/search', payload);
      if (resp?.data?.success) {
        dispatch(setDatas(resp.data.data));
      } else {
        dispatch(slice.actions.setHasError(resp?.data?.data || 'Search failed'));
      }
    } catch (err) {
      dispatch(slice.actions.setHasError(err.message));
    }
  };
}

export function addData({ formData }) {
  return async (dispatch) => {
    try {
      const resp = await axios.post('/gl_journal', formData);
      if (resp?.data?.success) {
        dispatch(slice.actions.setHasError(false));
        dispatch(searchData());
      } else {
        dispatch(slice.actions.setHasError(JSON.stringify(resp?.data?.data)));
      }
    } catch (err) {
      dispatch(slice.actions.setHasError(err.message));
    }
  };
}

export function editData({ id, formData, encryptedPin }) {
  return async (dispatch) => {
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const resp = await axios.patch(`/gl_journal/${id}`, formData );
      if (resp?.data?.success) {
        dispatch(slice.actions.setHasError(false));
        dispatch(searchData());
      } else {
        dispatch(slice.actions.setHasError(JSON.stringify(resp?.data?.data)));
      }
    } catch (err) {
      dispatch(slice.actions.setHasError(err.message));
    }
  };
}

export function deleteData({ item_list, encryptedPin }) {
  return async (dispatch) => {
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const resp = await axios.put('/gl_journal', {
        // item_list: item_list.map((v) => v.id),
        item_list: item_list,
      });
      if (resp?.data?.success) {
        dispatch(slice.actions.setHasError(false));
        dispatch(searchData());
      } else {
        dispatch(slice.actions.setHasError(resp?.data?.message));
      }
    } catch (err) {
      dispatch(slice.actions.setHasError(err.message));
    }
  };
}

export function voidJournal({ id }) {
  return async (dispatch) => {
    try {
      const resp = await axios.post(`/gl_journal/void/${id}`);
      if (resp?.data?.success) {
        dispatch(slice.actions.setHasError(false));
        dispatch(searchData());
      } else {
        dispatch(slice.actions.setHasError(JSON.stringify(resp?.data?.data)));
      }
    } catch (err) {
      dispatch(slice.actions.setHasError(err.message));
    }
  };
}

export default slice.reducer;